<template>
  <a-modal v-model="visible" title="失败详情" @ok="handleOk" width="800px">
    <div class="failure-details">
      <a-table :columns="columns" :data-source="data" :scroll="{ y: 500 }" :rowKey="'index'" :pagination="false">
        <template slot="msg" slot-scope="text">
          <span style="color: #ff5e47;">{{ text }}</span>
        </template>
      </a-table>
    </div>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        重新上传
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'FailureDetails',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80
        },
        {
          title: '类型',
          dataIndex: 'fileType',
          key: 'fileType'
        },
        {
          title: '资源名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '失败原因',
          dataIndex: 'msg',
          key: 'msg',
          scopedSlots: { customRender: 'msg' }
        }
      ]
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk(e) {
      console.log(e)
      this.visible = false
      this.$emit('changeMassUploadvisible', true)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
  padding-bottom: 15px !important;
}
/deep/ .ant-modal-footer {
  padding-bottom: 15px !important;
}
.failure-details {
  /deep/ .ant-table-scroll {
    border-radius: 6px;
  }
  /deep/ .ant-table-wrapper .ant-table-thead > tr > th {
    padding: 8px 16px;
  }
}
</style>
